import React, { useState } from 'react';
import { useMediaQuery } from 'react-responsive'
// import ReactDOM, { createRoot } from 'react-dom/client'

const StarRating = ({ name, changeStars = false, initval = 0 }) => {
    const [rating, setRating] = useState(parseInt(initval));
    const [hover, setHover] = useState(null);

    let valueText = null;
    let valueColor = null;

    // Perfecto
    // Excepcional
    // Muy bueno
    // Bueno 
    // Satisfactorio
    // Regular
    // Insatisfactorio
    // Malo
    // Muy Malo
    // Pésimo

    switch (rating) {
        case 1:
            valueText = 'Pésimo';
            valueColor = '#E24545';
            break;
        case 2:
            valueText = 'Muy Malo';
            valueColor = '#EA6855';
            break;
        case 3:
            valueText = 'Malo';
            valueColor = '#ED8854';
            break;
        case 4:
            valueText = 'Insatisfactorio';
            valueColor = '#F2A756';
            break;
        case 5:
            valueText = 'Regular';
            valueColor = '#F7C34C';
            break;
        case 6:
            valueText = 'Satisfactorio';
            valueColor = '#E0C549';
            break;
        case 7:
            valueText = 'Bueno';
            valueColor = '#C0CB45';
            break;
        case 8:
            valueText = 'Muy bueno';
            valueColor = '#9ECB43';
            break;
        case 9:
            valueText = 'Excelente';
            valueColor = '#7FCB3F';
            break;
        case 10:
            valueText = 'Perfecto';
            valueColor = '#5CAD37';
            break;
        default:
            valueText = '';
            valueColor = '#F5F5F';
            break;
    }

    const handleRating = (ratingValue) => {
        setRating(ratingValue);
        if (changeStars) {
            changeStars(ratingValue, name);
        }
    }

    const isMobile = useMediaQuery({ maxWidth: 1120 })
    const elemClass = 'd-flex gap-1 flex-wrap';

    return (
        <div className={elemClass}>
                {[...Array(10)].map((star, i) => {
                    const ratingValue = i + 1;
                    let color = '#e4e5e9';
                    let shadow = 'none';

                    return (
                        <label key={'labelStarRating_' + i} style={{ textShadow: shadow }} >
                            <input
                                className="radioStar"
                                type="radio"
                                name={name}
                                value={isNaN(rating) ? 0 : rating}
                                onChange={() => handleRating(ratingValue)}
                                checked={(ratingValue == rating ? 'checked' : '')}
                            />
                            <svg 
                                className="bi fs-3" 
                                style={{cursor:'pointer',color: ratingValue <= (hover || rating) ? valueColor : '#e4e5e9' }}
                                onMouseEnter={() => setHover(ratingValue)}
                                onMouseLeave={() => setHover(null)}
                            >
                                <use href={ rating > 0 && ratingValue <= (hover || rating) ? '#star-fill' : '#star' }></use>
                            </svg>

                        </label>
                    )
                })}
            {(rating > 0) && (
                <div>
                    <span style={{borderRadius: '20px', backgroundColor: valueColor }} className={`badge  badge-primary p-2`}>{rating} {valueText} </span>
                </div>
            )}
        </div>

    );
}

export default StarRating;

// if (document.getElementsByClassName("starRating")) {
//     const list = document.getElementsByClassName("starRating");
//     for (const item of list) {
//         createRoot(item).render(<StarRating {...item.dataset} />)
//     }
// }